import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export type SRCheatingFlowOpenedEventPayload = {
  funnel: string;
};

export class SRCheatingFlowOpenedEvent extends BaseEvent<SRCheatingFlowOpenedEventPayload> {}

export class SRCheatingFlowOpenedEventHandler extends BaseEventHandler<SRCheatingFlowOpenedEventPayload> {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof SRCheatingFlowOpenedEvent;
  }

  async track(event: SRCheatingFlowOpenedEvent) {
    const { funnel } = event.getPayload();

    return this.amplitudeService.logEvent('funnel_open_asknebula', {
      funnel,
    });
  }
}
